module.exports = __webpack_public_path__ + "static/media/cleaningMan.135fab01.svg";